/**
 * Created by r4zi4l on 02.04.2021
 */

const ThirdElementView = cc.Node.extend({
    ctor: function (thirdElement, unitView) {
        this._super();

        this.thirdElement = thirdElement;
        this.unitView = unitView;

        this.createPrize();
        this.createTimer();
    },

    createPrize: function () {
        const prize = this.prize = UnitView.getUnitImage(this.thirdElement.prize, {
            alignAnchorX: true,
            alignAnchorY: true
        });
        prize.setLocalZOrder(-1);
        this.unitView.addChild(prize);
        this.prize.setAlignment(this.unitView.width / 2, this.unitView.height / 2);
    },

    createTimer: function () {
        const styles = cleverapps.styles.ThirdElementView.timer;

        const timer = this.timer = new cleverapps.CountDownView(new cleverapps.CountDown(this.thirdElement.getTimeLeft()), {
            font: cleverapps.styles.FONTS.COMPONENT_TIMER_NO_BAR_TEXT,
            background: {
                frame: bundles.small_timer_merge.frames.timer_bg_png,
                width: styles.width,
                height: styles.height
            },
            icon: {
                frame: styles.adsIcon && this.thirdElement.unit.stage === 0 ? bundles.thirdelement.frames.ads_icon : bundles.small_timer_merge.frames.timer_png,
                json: bundles.small_timer.jsons.small_timer_json,
                animation: "animation"
            },
            showHours: false
        });
        timer.setAlignment(styles);
        timer.addChild(this.createButton());

        this.unitView.createAdditionalView("timer", timer);
    },

    createButton: function () {
        const styles = cleverapps.styles.ThirdElementView.timer.button;

        const buttonOptions = {
            width: styles.width,
            height: styles.height,
            type: cleverapps.styles.UI.Button.Images.field_button_blue
        };

        if (this.thirdElement.unit.stage === 0) {
            buttonOptions.text = `##${Messages.get("Watch")}`;
            buttonOptions.onClicked = this.thirdElement.watch.bind(this.thirdElement);
        } else {
            buttonOptions.text = Messages.get("ThirdElementView.buy");
            buttonOptions.onClicked = this.thirdElement.handleClick.bind(this.thirdElement);
        }

        const button = new cleverapps.UI.Button(buttonOptions);
        button.setAnchorPoint(0.5, 0.5);
        button.setAlignment(styles);

        return button;
    },

    helicopterAppearance: function () {
        const styles = cleverapps.styles.ThirdElementView;

        const unitView = this.unitView;
        unitView.sprite.setVisible(false);

        this.unitView.getAdditionalView("timer").hide(undefined, true);

        const helicopter = new cleverapps.Spine(bundles.thirdelement.jsons.thirdelement_json);
        helicopter.setAlignment(styles.helicopter);
        unitView.addChild(helicopter);
        helicopter.replaceParentSamePlace(Map2d.currentMap.getMapView().animations);

        this.prize.setVisible(false);
        this.prize.replaceParentSamePlace(helicopter);
        this.prize.setAlignment(styles.prize.x, styles.prize.y - this.prize.height / 2);

        const shine = new cleverapps.Spine(bundles.merge.jsons.buildable_above_json);
        shine.setLocalZOrder(1);
        shine.setAlignment(unitView.width / 2, unitView.height / 2);
        shine.setVisible(false);
        unitView.addChild(shine);

        const offset = styles.helicopter.offset;
        helicopter.runAction(new cc.Sequence(
            cleverapps.effects.fireAction("thirdelement.use"),
            new cc.DelayTime(0.5667),
            new cc.CallFunc(helicopter.runAction.bind(helicopter, new cc.RepeatForever(new cc.Sequence(
                new cc.MoveBy(1.25, offset.x, offset.y).easing(cc.easeQuadraticActionInOut()),
                new cc.MoveBy(1.25, -offset.x, -offset.y).easing(cc.easeQuadraticActionInOut())
            ))))
        ));

        this.prize.runAction(new cc.Sequence(
            new cc.DelayTime(0.5667),
            new cc.Show(),
            new cc.MoveBy(0.2, 0, -62),
            new cc.CallFunc(this.prize.runAction.bind(this.prize, new cc.RepeatForever(new cc.Sequence(
                new cc.ScaleTo(0.247, 0.92, 1),
                new cc.ScaleTo(0.169, 1, 1)
            ))))
        ));

        helicopter.setAnimation(0, "appearance", false);
        helicopter.setCompleteListener(() => {
            helicopter.stopAllActions();
            helicopter.setAnimation(0, "disappearance", false);
            helicopter.setCompleteListenerRemove();

            let endPosition = unitView.convertToWorldSpace(cc.p(unitView.width / 2, unitView.height / 2));
            endPosition = helicopter.convertToNodeSpace(endPosition);

            this.prize.runAction(new cc.Sequence(
                new cc.ScaleTo(0.2, 1, 1),
                new cc.MoveTo(0.17, endPosition.x, endPosition.y),
                new cc.CallFunc(() => {
                    if (!unitView.isRunning()) {
                        return;
                    }

                    this.prize.replaceParentSamePlace(unitView);
                    this.prize.runAction(new cc.Sequence(
                        cleverapps.effects.fireAction("merge.spawn.landing"),
                        new cc.ScaleTo(0.15, 1, 0.8),
                        new cc.ScaleTo(0.15, 1, 1)
                    ));

                    shine.setVisible(true);
                    shine.setAnimation(0, "animation_bonus", false);
                    shine.setCompleteListenerRemove();

                    unitView.sprite.setScale(0.3);
                    unitView.sprite.runAction(new cc.Sequence(
                        new cc.DelayTime(0.3),
                        new cc.Show(),
                        cleverapps.effects.fireAction("thirdelement.appear"),
                        new cc.ScaleTo(0.4, 1.3),
                        new cc.ScaleTo(0.2, 1),
                        new cc.CallFunc(() => {
                            const timer = unitView.getAdditionalView("timer");
                            if (timer) {
                                timer.animateAppear();
                            }
                        })
                    ));
                })
            ));
        });
    },

    planeAppearance: function () {
        const mapView = Map2d.currentMap.getMapView();

        const styles = cleverapps.styles.ThirdElementView;

        this.unitView.getAdditionalView("timer").hide(undefined, true);
        this.prize.setVisible(false);
        this.prize.runAction(new cc.Sequence(
            cleverapps.effects.fireAction("thirdelement.use"),
            new cc.ScaleTo(0.15, 1, 0.8),
            new cc.ScaleTo(0.15, 1, 1)
        ));

        const drop = new cleverapps.Spine(bundles.thirdelement.jsons.thirdelement_json);
        this.unitView.addChild(drop);
        drop.setAlignment(styles.drop);
        drop.replaceParentSamePlace(mapView.animations);
        const dropTimeout = this.sendPlane();
        this.unitView.sprite.setVisible(false);
        this.runAction(new cc.Sequence(
            new cc.DelayTime(dropTimeout),
            new cc.CallFunc(() => {
                drop.setAnimation(0, "gift", false);
                drop.setCompleteListenerRemove();
            }),
            cleverapps.effects.fireAction("merge.third_element.box"),
            new cc.DelayTime(1.2),
            new cc.CallFunc(() => {
                this.prize.setVisible(true);
                this.unitView.sprite.setVisible(true);
                if (this.unitView.sprite.hasAnimation("animation1")) {
                    this.unitView.sprite.setAnimationAndIdleAfter("animation1", "animation");
                } else {
                    this.unitView.sprite.setAnimation(0, "animation", true);
                }
            }),
            new cc.DelayTime(1),
            new cc.CallFunc(() => {
                const timer = this.unitView.getAdditionalView("timer");
                if (timer) {
                    timer.animateAppear();
                }
            })
        ));
    },

    sendPlane: function () {
        const styles = cleverapps.styles.ThirdElementView.plane;
        if (!styles) {
            return 0;
        }
        const mapView = Map2d.currentMap.getMapView();

        const plane = new cc.Sprite(bundles.thirdelement.frames.thirdelement_plane);
        this.unitView.addChild(plane);
        plane.setAlignment(styles);
        plane.replaceParentSamePlace(mapView.animations);

        let minTimeout = 0;
        while (cc.rectContainsPoint(mapView.visibleRect, plane)) {
            plane.x -= styles.speed.x;
            plane.y -= styles.speed.y;
            minTimeout += 0.5;
        }

        plane.runAction(new cc.RepeatForever(new cc.Sequence(
            new cc.MoveBy(0.5, styles.speed.x, styles.speed.y),
            new cc.CallFunc(() => {
                if (cc.rectContainsPoint(mapView.visibleRect, plane) || minTimeout > 0) {
                    minTimeout -= 0.5;
                } else {
                    plane.removeFromParent();
                }
            })
        )));

        return minTimeout;
    },

    playDestruction: function () {
        cleverapps.effects.fire("thirdelement.destroy");
        this.unitView.removeAdditionalView("timer");
    },

    playBuying: function (unit) {
        const mapView = Map2d.currentMap.getMapView();

        unit.hideAdditionalViews();

        const boughtUnitView = unit.onGetView();
        boughtUnitView.setVisible(false);

        const unitView = this.unitView;

        const animation = new cleverapps.Spine(bundles.merge.jsons.buildable_above_json);
        animation.setLocalZOrder(2);

        mapView.alignViewInGrid(unit.x, unit.y, animation);
        mapView.animations.addChild(animation);

        unitView.stopAllActions();
        unitView.runAction(new cc.Sequence(
            new cc.DelayTime(0.7),
            cleverapps.effects.fireAction("thirdelement.buy"),
            new cc.CallFunc(() => {
                animation.setAnimation(0, "animation", false);
                animation.setCompleteListenerRemove();
                unitView.removeAdditionalView("timer");
            }),
            new cc.ScaleTo(0.2, 0.3),
            new cc.RemoveSelf()
        ));

        boughtUnitView.runAction(new cc.Sequence(
            new cc.DelayTime(0.7),
            new cc.ScaleTo(0, 0.2),
            new cc.Show(),
            new cc.ScaleTo(0.2, 1),
            new cc.DelayTime(0.2),
            new cc.CallFunc(() => {
                unit.showAdditionalViews();
            })
        ));

        cleverapps.pointerManager.removeAll(this.timer, true);
    }
});

cleverapps.styles.ThirdElementView = {
    timer: {
        x: { align: "center", dx: 0 },
        y: { align: "center", dy: -10 },
        width: 110,
        height: 32,

        button: {
            x: { align: "center" },
            y: { align: "bottom", dy: -56 },
            width: 130,
            height: 50,
            padding: {
                left: 12,
                right: 12,
                top: 5,
                bottom: 11
            },
            margin: 0
        }
    },

    prize: {
        x: { align: "center" },
        y: 322
        // offset: {
        //     y: 62
        // }
    },

    helicopter: {
        x: { align: "center" },
        y: { align: "bottom" },
        offset: {
            x: 20,
            y: 10
        }
    },

    bubble: {
        offset: {
            y: -6
        }
    },

    adsButton: {
        icon: {
            x: { align: "right", dx: -10 },
            y: { align: "center", dy: 4 },
            scale: 0.55
        },

        text: {
            x: { align: "left" },
            y: { align: "center" }
        }
    }
};
